"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lendingPool_1 = __importDefault(require("./lendingPool"));
const onchainInteractionsLendingVault_1 = __importDefault(require("./onchainInteractionsLendingVault"));
const routers_1 = require("../../config/contracts/routers");
const ethers_1 = require("ethers");
const onchainInteractionsConfigManager_1 = __importDefault(require("./onchainInteractionsConfigManager"));
const ZERO = ethers_1.BigNumber.from(0);
class OnchainInteractions {
    constructor(onchain, accountAddress) {
        this.cache = {};
        this.getOnchain = () => this.onchain;
        this.getAccountAddress = () => this.accountAddress;
        this.getConfigManager = () => this.configManager;
        this.onchain = onchain;
        this.accountAddress = accountAddress;
        this.configManager = new onchainInteractionsConfigManager_1.default(this, onchain.getConfigManager());
        this.lendingPools = {};
        this.lendingVaults = {};
    }
    getAccount() {
        return this.onchain.getAccount(this.accountAddress);
    }
    cleanCache() {
        return __awaiter(this, void 0, void 0, function* () {
            this.cache = {};
        });
    }
    initializeLendingPool(factory, pair) {
        const lendingPool = this.onchain.getImpermaxFactory(factory).getLendingPool(pair);
        return new lendingPool_1.default(this, lendingPool);
    }
    getLendingPool(factory, pair) {
        if (!this.lendingPools[factory])
            this.lendingPools[factory] = {};
        const interactionsLendingPools = this.lendingPools[factory];
        if (!interactionsLendingPools[pair])
            interactionsLendingPools[pair] = this.initializeLendingPool(factory, pair);
        return interactionsLendingPools[pair];
    }
    initializeLendingVault(vaultAddress) {
        const lendingVault = this.onchain.getLendingVault(vaultAddress);
        return new onchainInteractionsLendingVault_1.default(this, lendingVault);
    }
    getLendingVault(vaultAddress) {
        if (!this.lendingVaults[vaultAddress])
            this.lendingVaults[vaultAddress] = this.initializeLendingVault(vaultAddress);
        return this.lendingVaults[vaultAddress];
    }
    send(method, onTransactionHash, value = ZERO) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield method.call({ from: this.accountAddress, value });
                return method.send({
                    from: this.accountAddress,
                    value: value,
                    maxPriorityFeePerGas: null,
                    maxFeePerGas: null
                }).on('transactionHash', onTransactionHash);
            }
            catch (e) {
                console.error(e);
                throw e;
            }
        });
    }
    getDefaultRouterContract() {
        if (!this.cache.defaultRouterContract) {
            const address = routers_1.DEFAULT_ROUTER[this.onchain.network];
            if (!address) {
                console.error("DefaultRouter address not found");
                return null;
            }
            this.cache.defaultRouterContract = this.onchain.getContractHelper().newRouter(address);
        }
        return this.cache.defaultRouterContract;
    }
    claimAirdrop(airdropData, merkleDistributor, onTransactionHash) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.send(merkleDistributor.methods.claim(airdropData.index, this.accountAddress, airdropData.amount, airdropData.proof), onTransactionHash);
        });
    }
    claims(pairAddresses, onTransactionHash) {
        return __awaiter(this, void 0, void 0, function* () {
            const requests = [];
            for (const factory in pairAddresses) {
                for (const pairAddress of pairAddresses[factory]) {
                    const accountLendingPool = yield this.getAccount().getLendingPool(factory, pairAddress);
                    for (const accountBorrowable of [
                        accountLendingPool.getBorrowableA(),
                        accountLendingPool.getBorrowableB(),
                    ]) {
                        requests.push((() => __awaiter(this, void 0, void 0, function* () {
                            const borrowable = accountBorrowable.getPoolToken();
                            const pendingReward = (yield accountBorrowable.getAvailableFarmingReward()) + (yield accountBorrowable.getAvailableRewarderReward());
                            return {
                                hasPendingReward: pendingReward > 0,
                                hasImpermaxChef: yield borrowable.hasImpermaxChef(),
                                borrowableAddress: yield borrowable.getPoolTokenAddress(),
                            };
                        }))());
                    }
                }
            }
            const data = yield Promise.all(requests);
            const toClaim = [];
            for (const borrowable of data) {
                if (!borrowable.hasPendingReward)
                    continue;
                toClaim.push(borrowable.borrowableAddress);
            }
            if (toClaim.length > 0) {
                const impermaxChef = this.onchain.getContractHelper().impermaxChef;
                return this.send(impermaxChef.methods.massHarvest(toClaim, this.accountAddress), onTransactionHash);
            }
        });
    }
    claimDistributor(claimableAddress, onTransactionHash) {
        return __awaiter(this, void 0, void 0, function* () {
            const claimable = this.onchain.getContractHelper().newClaimable(claimableAddress);
            return this.send(claimable.methods.claim(), onTransactionHash);
        });
    }
}
exports.default = OnchainInteractions;
